export const chargerTypes = {
  schuko: "Schuko",
  cee: "CEE",
  type2: "Type2",
  ccs: "CCS",
  chademo: "CHADEMO",
  tesla: "Tesla"
} as const

export const chargerTypesFromBackend = {
  DOMESTIC_A: "schuko",
  DOMESTIC_B: "schuko",
  DOMESTIC_C: "schuko",
  DOMESTIC_D: "schuko",
  DOMESTIC_E: "schuko",
  DOMESTIC_F: "schuko",
  DOMESTIC_G: "schuko",
  DOMESTIC_H: "schuko",
  DOMESTIC_I: "schuko",
  DOMESTIC_J: "schuko",
  DOMESTIC_K: "schuko",
  DOMESTIC_L: "schuko",

  IEC_60309_2_single_16: "cee",
  IEC_60309_2_three_16: "cee",
  IEC_60309_2_three_32: "cee",
  IEC_60309_2_three_64: "cee",

  IEC_62196_T1: "type2",
  IEC_62196_T2: "type2",
  IEC_62196_T3A: "type2",
  IEC_62196_T3C: "type2",

  IEC_62196_T1_COMBO: "ccs",
  IEC_62196_T2_COMBO: "ccs",

  CHADEMO: "chademo",

  TESLA_R: "tesla",
  TESLA_S: "tesla"
} as const

export interface MaintenanceMode {
  description: {
    en: string
    hu: string
  }
  enabled: true
  lastUpdated: string
}

export interface DynamicConfig {
  acChargerBaseOfCalculation: string
  acChargerPrice: number
  currency: string
  dcChargerBaseOfCalculation: string
  dcChargerPrice: number
  prepayAmount: number
  rapidChargerBaseOfCalculation: string
  rapidChargerPrice: number
  validFrom: string
  hideRegistrationCharge: boolean
  guestCommission: number
  registrationCharge: number
  isPriceInfoVisible: boolean
  redirectUrl: string
  maintenanceMode: MaintenanceMode
}

export interface RegistrationDocument {
  documentId: string
  documentTitle: string
  documentVariantId: string
  isOptional: boolean
  prefix: string
  suffix: string
  url: string
  versionNumber: number
}

export interface UserData {
  languagePreference: string
  isTermsAndConditionsAccepted: boolean
  email: string
  recaptchaToken?: string
}

export interface AccountingInfo {
  firstName?: string
  lastName?: string
  address?: string
  city?: string
  postCode?: string
  country?: string
  companyName?: string
  taxNumber?: string
  groupCode?: string
  phoneNumber?: string
}

export interface Charger {
  address?: string
  connector?: Connector
}

export interface Connector {
  id?: string
  evseId?: string
  label?: string
  type?: string
  status?: string
  power?: number
  voltage?: number
  price?: {
    amountPerUnit: number
    currency: string
    pricingUnit: string
  }
  mode?: string
  current?: number
  connectorType?: keyof typeof chargerTypesFromBackend
  connectorFormat?: string
  stationNumber?: string
}
